import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_VATRETURN_DETAIL: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'SetVatReturnDetail'
);

export const SET_COUNTRIES_WITH_VAT_RATE: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'SetCountriesWithVatRate'
);

export const SET_SUPPLIES_FROM_MEMBER_STATE_OF_IDENTIFICATION: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'SetSuppliesFromMemberStateOfIdentification'
);

export const SET_SUPPLIES_FROM_FIXED_ESTABLISHMENTS: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'SetSuppliesFromFixedEstablishments'
);

export const SET_FIXED_ESTABLISHMENTS_OF_VAT_RETURN: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'SetVatEstablishmentsOfVatReturn'
);

export const TEMPORARY_SAVE_VAT_RETURN: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'TemporarySaveVatReturn'
);

export const FINAL_SAVE_VAT_RETURN: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'FinalSaveVatReturn'
);

export const SUBMIT_NIL_VAT_RETURN: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'SubmitNilVatReturn'
);

export const SET_QUARTERS: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'SetQuarters'
);

export const SET_MONTH_QUARTERS: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'SetMonthQuarters'
);

export const SET_VAT_CORRECTIONS: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'SetVatCorrections'
);

export const SET_CORRECTIONS_COUNTRIES: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'SetCorrectionsCountries'
);

export const SET_MSCON: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'SetMscon'
);

export const RESET_REDUCER: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'ResetReducer'
);

export const SET_COUNTRIES_WITH_VAT_RATE_FEST: string = typeCreatorV2(
  'VatReturnDetailReducer',
  'SetCountriesWithVatRateFEst'
);
